module.exports = __webpack_public_path__ + "img/oman.288b67ad.png";